var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.showPopup($event)}}},[_vm._v("\n  "+_vm._s(_vm.$t("starter.start_trial"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }